@if (image) {
  <div
    [ngClass]="{
      'container mx-auto max-w-640': useContainer,
      'max-w-full': useContainer && displayKiosk,
      'pt-5': useContainer && paddingTop === 'small',
      'pt-10': useContainer && paddingTop === 'large',
      'pb-5': useContainer && paddingBottom === 'small',
      'pb-10': useContainer && paddingBottom === 'large',
    }"
  >
    @if (linkUrl) {
      <a
        [link]="linkUrl"
        [target]="linkTarget"
        class="block"
      >
        <img
          [style]="heightStyles()"
          [src]="image.url"
          class="w-full"
        />
      </a>
    }
    @if (!linkUrl) {
      <img
        [style]="heightStyles()"
        [src]="image.url"
        class="w-full"
      />
    }
  </div>
}
